import { __assign } from "tslib";
// DS: 9.11
import React from 'react';
import cn from 'classnames';
import DeviationDumbView from '../DeviationViews/Dumbo';
import Stats from '../Stats';
import TextRenderer from '../TextRenderer/TextRenderer';
import FloatingIndicators from './_partials/FloatingIndicators';
import Details from './_partials/Details';
import ShopCardLink from './_partials/ShopCardLink';
import s from './ShopCard.scss';
export var THUMB_HEIGHT = 200;
var ShopCard = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, width = _a.width, style = _a.style, _d = _a.showDescription, showDescription = _d === void 0 ? false : _d, _e = _a.showStats, showStats = _e === void 0 ? true : _e, _f = _a.showStatusIndicator, showStatusIndicator = _f === void 0 ? false : _f;
    var statsHidden = !showStats || ((_c = (_b = deviation.stats) === null || _b === void 0 ? void 0 : _b.favourites) !== null && _c !== void 0 ? _c : 0) < 1;
    return (React.createElement("div", { className: s['root'], style: __assign(__assign({}, style), { width: width, height: 'auto' }) },
        React.createElement(ShopCardLink, { className: s['linked-area'], deviation: deviation },
            React.createElement(FloatingIndicators, { deviation: deviation, showStatusIndicator: showStatusIndicator }),
            React.createElement(DeviationDumbView, { className: s['thumb'], deviation: deviation, width: width, height: THUMB_HEIGHT }),
            React.createElement(Stats, { className: cn(s['stats'], statsHidden && s['hidden']), deviation: deviation, withDas: false, withViewCount: false, withBadges: false, withCommentControl: false, withSubscriberCount: false, withUserList: false, onlyNumbers: true })),
        React.createElement(Details, { className: s['details'], deviation: deviation }),
        showDescription && deviation.textContent && (React.createElement("div", { className: s['description'] },
            React.createElement(TextRenderer, { className: s['description-text'], textContent: deviation.textContent })))));
};
ShopCard.displayName = 'ShopCard';
export default ShopCard;
//# sourceMappingURL=ShopCard.js.map